import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_STORAGE_SECRET;

/* ---------- Encrypt ---------- */
export const encryptData = (data) => {
  try {
    const stringData = JSON.stringify(data);

    return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

/* ---------- Decrypt ---------- */
export const decryptData = (cipherText) => {
  try {
    if (!cipherText) return null;

    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
